"use client";

import { useState } from "react";
import { AbyssMedia } from "../AbyssMedia/AbyssMedia";
import type { IVideoPlayerProps } from "./VideoPlayer.props";

export const VideoPlayer = ({
  banner,
  directVideo,
  source,
  vimeoVideo,
  youtubeVideo,
}: IVideoPlayerProps) => {
  const video =
    source === "direct" ? directVideo : source === "youtube" ? youtubeVideo : vimeoVideo;
  const [playing, setPlaying] = useState(false);
  if (!video) return null;
  const autoplay = `${video}${video.includes("?") ? "&" : "?"}autoplay=1`;
  const player =
    source === "direct" ? (
      <video
        autoPlay={playing}
        className="absolute inset-0 h-full w-full bg-absolute-black object-cover"
        controls
        playsInline
        src={video}
      />
    ) : (
      <iframe
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="absolute inset-0 h-full w-full"
        loading="lazy"
        src={playing ? autoplay : video}
        title={`${source} video`}
      />
    );
  return (
    <div className="abyss-instrument-frame relative aspect-video overflow-hidden border border-iron bg-absolute-black">
      {banner && !playing ? (
        <button
          aria-label="Play video"
          className="group absolute inset-0 block h-full w-full cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ring"
          onClick={() => setPlaying(true)}
          type="button"
        >
          <AbyssMedia
            aspectRatio="16:9"
            className="pointer-events-none h-full"
            imageClassName="object-cover transition-transform duration-300 ease-out group-hover:scale-[1.015]"
            media={banner.image}
            sizes="(min-width: 1280px) 1184px, 100vw"
          />
          <span aria-hidden="true" className="absolute inset-0 bg-absolute-black/25" />
          <span className="absolute left-1/2 top-1/2 inline-flex min-h-12 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-lg border border-frost bg-absolute-black px-5 font-abyss-body text-sm font-medium text-frost transition-[background-color,color,transform] duration-200 group-hover:scale-105 group-hover:bg-frost group-hover:text-absolute-black group-active:scale-95">
            Play
          </span>
        </button>
      ) : (
        player
      )}
    </div>
  );
};

VideoPlayer.displayName = "Content::VideoPlayer";
